export const FOOTER = {
  'PRIVACY': 'Privacy Policy',
  'TERMS': 'Terms',
  'IDEAS': 'Ideas & Feedback'
};
